export default __webpack_public_path__ + "d191308efd358be0f2836c4075c9f324.svg";